import { render, staticRenderFns } from "./emotion.vue?vue&type=template&id=5ae2bafc&scoped=true"
import script from "./emotion.vue?vue&type=script&lang=js"
export * from "./emotion.vue?vue&type=script&lang=js"
import style0 from "./emotion.vue?vue&type=style&index=0&id=5ae2bafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2bafc",
  null
  
)

export default component.exports